const NotFound=()=>{
    return (
        <div className="main-content">
            <div className="d-flex justify-content-center">
                <h4 className="pt-4">Page Not Found</h4>
            </div>
        </div>
    )
}
export default NotFound;